import gql from "graphql-tag";

export const ROLES_QUERY = gql`
  query GetRolesQuery {
    roles {
      ldapDN
      ldapUUID
      name
      scopes
      default
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/RolesQuery/queries.ts